<template>
  <div class="privacy-policy-container">
    <iframe
      :src="privacyUrl"
      frameborder="0"
      class="privacy-iframe"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: "PrivacyPolicy",
  computed: {
    privacyUrl() {
      const locale = this.$i18n.locale;
      if (locale === 'ja' || locale === 'jp') {
        return '/privacy_ja.html';
      }
      return '/privacy.html';
    }
  }
};
</script>

<style lang="scss" scoped>
.privacy-policy-container {
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

.privacy-iframe {
  width: 100%;
  height: 100%;
  border: none;
}
</style>
